export { AmountProperties as NumberProperties } from './AmountDocs'
